<template>
  <eventi-list-component :titoloEvento="titoloEvento" :utente="utente" :key="keyListaEventi" :pathEventResource="pathEventResource" :linkEvent="linkEvent" :gruppo="gruppo" :tipoEvento="tipoEvento"></eventi-list-component>
</template>
<script>
import UtilityMixin from "../../../../../utility/UtilityMixin";
import EventiListComponent from "../../../base/components/EventiListComponent.vue";
import EventiMixin from "../../../utility/mixins/EventiMixins";
export default {
  components: { EventiListComponent },
  mixins: [UtilityMixin, EventiMixin],
  props: {
    utente: {
      type: Object,
      default: function () {
        return null;
      },
    },
  },
  computed: {
    idPaziente() {
      return this.$route.query.idPaziente;
    },
    linkPatient() {
      return EventiMixin.getLinkPatient(this.utente, this.idPaziente);
    },
    rows() {
      return this.items.length;
    },
  },
  mounted() {
    let me = this;
    me.id = this.$route.params.id;
  },
  data() {
    return {
      showModalLoading: false,
      titoloEvento: this.$i18n.t("patients.gastroenterology.physiologicalHistory"),
      linkEvent: "/paziente/gastroenterologia/anamnesifisiologica",
      pathEventResource: "/gastroanamnesifisiologica",
      keyListaEventi: 0,
      gruppo: "GASTROENTEROLOGIA",
      tipoEvento: "ANAMNESI FISIOLOGICA",
    };
  },
  methods: {},
};
</script>
